var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Inner } from '@finect/tabular-core/Inner';
const betaBefore = (theme, reveal) => css(["> div > div{padding-top:3px;}::before{content:'';position:absolute;top:0;left:0;background-color:#f03c3c;height:6px;width:100%;z-index:1000;transition:transform 0.25s cubic-bezier(0.49,0.42,0.52,0.98);", " ", "}"], !reveal && "transform: translateY(".concat(60 - theme.collapsedNavHeight, "px);"), maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), !reveal && "transform: translateY(".concat(theme.mobileNavHeight - 6, "px);")));
export const OmniNavBlock = styled.div.withConfig({
  displayName: "OmniNavBlock",
  componentId: "sc-1gwfqgb-0"
})(["position:fixed;z-index:200;top:0;left:0;right:0;height:60px;backface-visibility:hidden;transition:transform 0.25s cubic-bezier(0.49,0.42,0.52,0.98);", ";", ";", " ", " ", ""], _ref => {
  let {
    reveal
  } = _ref;
  return !reveal && "pointer-events: none;";
}, _ref2 => {
  let {
    reveal,
    theme
  } = _ref2;
  return !reveal && "transform: translateY(".concat(theme.collapsedNavHeight - theme.navHeight, "px);");
}, _ref3 => {
  let {
    withShadow,
    reveal
  } = _ref3;
  return withShadow && reveal ? 'box-shadow: 0px 4px 16px rgba(46, 46, 51, 0.5);' : '';
}, maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: ", "px;\n    ", ";\n  "])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.mobileNavHeight;
}, _ref5 => {
  let {
    reveal,
    theme
  } = _ref5;
  return !reveal && "transform: translateY(".concat(theme.collapsedNavHeight - theme.mobileNavHeight, "px);");
}), _ref6 => {
  let {
    reveal,
    theme
  } = _ref6;
  return isPreRelease && betaBefore(theme, reveal);
});
export const MainNav = styled.div.withConfig({
  displayName: "OmniNavBlock__MainNav",
  componentId: "sc-1gwfqgb-1"
})(["position:relative;z-index:300;height:60px;background-color:", ";pointer-events:auto;"], _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.mainColor;
});
export const MainNavContainer = styled(Inner).withConfig({
  displayName: "OmniNavBlock__MainNavContainer",
  componentId: "sc-1gwfqgb-2"
})(["display:flex;align-items:center;justify-content:space-between;", ""], _ref8 => {
  let {
    fullWidth
  } = _ref8;
  return fullWidth ? 'max-width: 100%;' : '';
});